import { Expose } from "class-transformer";
import { BasicUser } from "./basic-user-model";

export class StudentModel extends BasicUser {
    @Expose() currency : string ;
    @Expose() enableVideoRecording : boolean ;
    @Expose() enableVoiceRecording : string ;
    @Expose() isCallsBlocked : boolean ;
    @Expose() isLoginBlocked : boolean ;
    @Expose() isNewMuslim : boolean ;
    @Expose() isPayPackagesBlocked : boolean ;
    @Expose() isReserveBlocked : boolean ;
    @Expose() rate : number;
}